// home.jsx




import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from "../../../../Services/apiaxios.js";
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content';
import Menu from "../../components/Menu/menu.jsx";
import CardCategorias from "../../components/Categorias/categorias.jsx";
import BuscaCidade from "../../components/Busca/buscacidade.jsx";
import Footer from "../../components/Footer/footer.jsx";
import MenuConfig from "../../components/Menu/menuconfig.jsx";
import handleApiError from '../../../../Services/apiErrorHandler.js';
import { encrypt, decrypt } from "../../../../Services/cryptoUtils.js";
import { getUserData } from "../../../../Services/userutils.js";
import { autoLogout } from "../../../../Services/authutils.js";

import './home.css';

function Home() {
    const initialUserData = getUserData();
    const [userId, setUserId] = useState(initialUserData.userId);
    const [usu_cidade, setUsu_Cidade] = useState(initialUserData.cidade);
    const [categorias, setCategorias] = useState([]);
    const [nenhumaCategoriaEncontrada, setNenhumaCategoriaEncontrada] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const MySwal = withReactContent(Swal);
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    const tokenlg = localStorage.getItem("tokenlg");
    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            autoLogout();
        }
    }, [tokenASW, tokenlg]);

    useEffect(() => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);

                if (decryptedUser) {
                    setUsu_Cidade(decryptedUser.cidade);
                    setUserId(decryptedUser.id_usuario); 
                }
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
            }
        }
    }, []); // Dependência vazia para rodar uma vez após a montagem do componente


    useEffect(() => {
        if (usu_cidade) {
            atualizarCategorias(usu_cidade);
        }
    }, [usu_cidade]);

    useEffect(() => {
        const buscaCidade = localStorage.getItem("buscaCidade");
        if (buscaCidade === "true") {
            setIsDisabled(false);
        } else {
            setIsDisabled(true);
        }
    }, []);

    useEffect(() => {
        atualizarCategorias(usu_cidade);
    }, [usu_cidade]); // acrescentei atualizarCategorias pois o react reclamou: Line 119:8:  React Hook useEffect has a missing dependency: 'atualizarCategorias'. Either include it or remove the dependency array  react-hooks/exhaustive-deps 22/6/24w // gerou loop infinito do loading 29/6/24w

    const atualizarCategorias = (cidade) => {
        setLoading(true); // eliminado temporariamente 29/6/24w
        const url = `/categoria/listar?cidade=${encodeURIComponent(cidade)}`;
        apiaxios.get(url)
            .then((response) => {
                setLoading(false);

                if (response.data.retorno) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Erro ao carregar agendamentos: ' + response.data.retorno,
                        timer: 3000,
                        timerProgressBar: true
                    });
                } else {
                    if (response.data.length === 0) {
                        setNenhumaCategoriaEncontrada(true);
                        MySwal.fire({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            icon: 'info',
                            title: 'Nenhuma categoria encontrada neste momento...'
                        });
                    } else {
                        setNenhumaCategoriaEncontrada(false);
                        setCategorias(response.data);
                    }
                }
            })
            .catch(error => {
                setLoading(false);
                handleApiError(error);
            });
    };

    const handleCidadePesquisada = (cidade) => {
        setUsu_Cidade(cidade);
        atualizarCategorias(cidade);
    
        // Descriptografa os dados do usuário
        const encryptedUser = localStorage.getItem("tokenacw");
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser); // Descriptografa os dados
    
                if (decryptedUser) {
                    // Atualiza a cidade no objeto do usuário
                    setUsu_Cidade(decryptedUser.cidade);
    
                    // Criptografa novamente os dados atualizados
                    const reEncryptedUser = encrypt(JSON.stringify(decryptedUser));
                    localStorage.setItem("usuario", reEncryptedUser);
    
                    // Atualiza o estado de buscaCidade e isDisabled
                    localStorage.setItem("buscaCidade", false);
                    setIsDisabled(true); // Desabilita após pesquisa
                }
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
            }
        }
    };
    
    const handleTrocarCidadeClick = () => {
        localStorage.setItem("buscaCidade", true);
        setIsDisabled(false); // Ativa o botão e o input
    };

    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page='home' />
                        </div>
                        <div className="col py-2 me-3">
                            <MenuConfig id_usuario={userId} page="home" onTrocarCidadeClick={handleTrocarCidadeClick} />
                            <div className="container-fluid">
                                <BuscaCidade onCidadePesquisada={handleCidadePesquisada} isDisabled={isDisabled} setIsDisabled={setIsDisabled} />
                                <h4 className="text-center">Meus Favoritos</h4>
                                <div className="row">
                                    <div className={`row ${loading ? 'd-none' : ''}`}></div>
                                    {loading && (
                                        <div className="loading-spinner-container">
                                            <Oval color="#00BFFF" height={80} width={80} />
                                        </div>
                                    )}
                                    {nenhumaCategoriaEncontrada ? (
                                        <div className="alert alert-danger mt-2" role="alert">
                                            Nenhuma "Categoria" disponível pra esta cidade neste momento...
                                        </div>
                                    ) : (
                                        categorias.map(categoria => (
                                            <div className="col-lg-3 ml-10 col-md-4 col-sm-12" key={categoria.ID_CATEGORIA}>
                                                <div className="text-center">
                                                    <CardCategorias
                                                        categoria_id={categoria.ID_CATEGORIA}
                                                        categoria_icone={categoria.ICONE}
                                                        categoria_descricao={categoria.DESCRICAO}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Home;